import React, { Component } from 'react';
import styled from 'styled-components';
import { Column, Text, Button } from '../../../theme/index';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter, Link } from 'react-router-dom';

const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 50px;
  height: 100%;
  margin: 0 auto;
  @media (min-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-auto-rows: auto;
`;

const StyledColumn = styled(Column)`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  height: 100%;
  align-items: center;
  text-align: center;
`;

function Box({ img, title, text, link }) {
  return (
    <React.Fragment>
      {link && (
        <Link to={link}>
          <StyledColumn>
            <img src={img} alt={`${img} Icon AchieveCE`} />
            <Column width="85%">
              <Text protitle color="#2b2b2b">
                {title}
              </Text>
              <Text color="#2b2b2b">{text}</Text>
            </Column>
          </StyledColumn>
        </Link>
      )}
      {!link && (
        <StyledColumn>
          <img src={img} alt={`${img} Icon AchieveCE`} />
          <Column width="85%">
            <Text protitle color="#2b2b2b">
              {title}
            </Text>
            <Text color="#2b2b2b">{text}</Text>
          </Column>
        </StyledColumn>
      )}
    </React.Fragment>
  );
}

class Professions extends Component {
  render() {
    const {
      error,
      professionIcons,
      professionIconsConnection,
    } = this.props.data;
    if (error) return <h1>Error fetching posts!</h1>;
    if (professionIcons && professionIconsConnection) {
      return (
        <Column alignitems="center" margin="6em 0">
          <Wrapper>
            {professionIcons &&
              professionIcons.map((key, index) => {
                return (
                  <Box
                    key={index}
                    img={`https://media.graphcms.com/${key.icon.handle}`}
                    title={key.title}
                    text={key.description}
                    link={key.link && key.link}
                  />
                );
              })}
          </Wrapper>
          <Button
            primary
            margin="2em 0 0 0"
            onClick={() => this.props.history.push('/findce')}
          >
            See all professions
          </Button>
        </Column>
      );
    } else {
      return null;
    }
  }
}

export const professions = gql`
  query professions {
    professionIcons {
      id
      slug
      title
      link
      description
      icon {
        handle
      }
    }
    professionIconsConnection {
      aggregate {
        count
      }
    }
  }
`;

export default withRouter(
  graphql(professions, {
    props: ({ data }) => ({
      data,
    }),
  })(Professions)
);



// WEBPACK FOOTER //
// ./src/components/screens/Home/components/Professions.jsx